// extracted by mini-css-extract-plugin
export default {"header":"fy","fullPage":"gy","closed":"hy","minimize":"iy","redcircle":"jy","container":"ky","text":"ly","centered":"my","escapex":"ny"};
    if(module.hot) {
      // 1738064238403
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  